import { Ref, ref, UnwrapRef } from "vue";

export function getImageType(imagePath: string): {
  imageType: Ref<UnwrapRef<string>>;
} {
  const imageType = ref<string>("");

  const setImageType = () => {
    const imageExtension = imagePath.split(".").pop()?.toLowerCase();
    switch (imageExtension) {
      case "jpg":
      case "jpeg":
        imageType.value = "image/jpeg";
        break;
      case "png":
        imageType.value = "image/png";
        break;
      case "gif":
        imageType.value = "image/gif";
        break;
      default:
        imageType.value = "application/octet-stream";
        break;
    }
  };

  setImageType();

  return { imageType };
}
